<!-- eslint-disable max-len -->
<template>
    <div
        :class="[
            'horizontal-tab',
            {
                'client-skin-adapt': isSkinAuto,
                dark: isSkinDark
            }
        ]"
        :style="cssProperties"
        ref="horizontalTabRef"
    >
        <div class="horizontal-tab-header" ref="horizontalTabHeaderRef">
            <div ref="fakeTabHeaderRef" class="horizontal-tab-header-fake"></div>
            <div
                class="horizontal-tab-header-real"
                ref="tabHeaderRealRef"
                :class="{
                    'horizontal-tab-header-scroll': shouldScroll
                }"
            >
                <a
                    v-for="item of headerItems"
                    :key="item.id"
                    href="javascript:void(0)"
                    class="horizontal-tab-part"
                    @click="() => clickMe(item)"
                    :class="{ active: item.active, circle: !isLineMode }"
                >
                    <span v-html="item.props.title"></span>
                </a>
                <div class="horizontal-tab-header-active-bar" v-if="isLineMode"></div>
                <div class="horizontal-tab-header-long-bar" v-if="isLineMode"></div>
            </div>
        </div>
        <div class="horizontal-tab-body" ref="horizontalTabBodyRef">
            <transition name="fade">
                <inner-children-renderer v-if="_child" :children="_child" :key="_child && _child.id" />
            </transition>
        </div>
    </div>
</template>

<script >
import { computed, ref, watch, nextTick } from 'vue-demi';
import { useCssProperties } from '../composables/useCssProperties';
import { useHeaderItems } from '../composables/useHeaderItems';
import { useHeaderBar } from '../composables/useHeaderBar';
import { useHeaderHorizScroll } from '../composables/useHeaderHorizScroll';
import { useHeaderFixed } from '../composables/useHeaderFixed';
import { useViewport } from '../composables/useViewport';
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
import { CHILD } from '../constant';
import ChildItem from '../children/tab-pane/render/index.vue';
const __sfc_main = {
  name: 'horizontal-tab',
  mixins: [ComplexComp.Inner.Parent.Mixins({
    [CHILD]: ChildItem
  })]
};
__sfc_main.props = {
  tpl: Object
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useDark
  } = require('@fegobull/webapi').use;
  const {
    isPreRender
  } = require('../utils');
  const props = __props;
  const horizontalTabRef = ref(null);
  const horizontalTabHeaderRef = ref(null);
  const horizontalTabBodyRef = ref(null);
  const tabHeaderRealRef = ref(null);
  const {
    isAuto: isSkinAuto,
    isDark: isSkinDark
  } = useDark?.() || {};
  const {
    cssProperties
  } = useCssProperties(props);
  const {
    current,
    activeChild,
    headerItems
  } = useHeaderItems({
    horizontalTabRef,
    props
  });
  const {
    shouldScroll,
    scrollNavToHorizontalCenter
  } = useHeaderHorizScroll({
    horizontalTabRef,
    props
  });
  const {
    isLineMode,
    resetHeaderBar
  } = useHeaderBar({
    horizontalTabRef,
    props
  });
  const {
    scrollNavToVerticalTop
  } = useHeaderFixed({
    horizontalTabRef,
    props
  });
  const {
    viewportWidth
  } = useViewport({
    horizontalTabRef,
    props
  });
  const _child = computed(() => activeChild.value);
  const clickMe = v => {
    const dirty = current.value !== v.id;
    current.value = v.id;
    try {
      // 超出画面内容 - 滚动当前激活到中间
      if (shouldScroll.value) {
        scrollNavToHorizontalCenter();
      }
      // 吸顶 - 垂直滚动至 TAB 头部吸顶
      if (props.tpl.props.fixedHeader) {
        scrollNavToVerticalTop();
      }
      // 更新下划线
      if (dirty) {
        resetHeaderBar();
      }
    } catch (err) {
      console.error('=======clickMe=======', err);
    }
  };
  const setActive = idx => {
    // 找一下当前的tab是否有子tab，如果有，就切换到第一个子tab
    const index = parseInt(idx);
    const child = props.tpl.children[index - 1];
    if (child) {
      // 模拟点击
      clickMe(child);
    }
  };

  // 视口变化
  watch(() => viewportWidth.value, () => {
    nextTick(() => {
      if (isPreRender()) {
        return;
      }
      // 更新下划线
      resetHeaderBar();
      // 变更 header-real 的 max-width 值，否则 fixed 时会超出 750
      const horizontalTab = horizontalTabRef.value;
      const horizontalTabRealHeader = tabHeaderRealRef.value;
      if (horizontalTab && horizontalTabRealHeader) {
        const maxWidth = horizontalTab.getBoundingClientRect().width + 'px';
        horizontalTabRealHeader.style.maxWidth = maxWidth;
      }
    });
  }, {
    immediate: true
  });
  return Object.assign({
    horizontalTabRef,
    horizontalTabHeaderRef,
    horizontalTabBodyRef,
    tabHeaderRealRef,
    isSkinAuto,
    isSkinDark,
    cssProperties,
    headerItems,
    shouldScroll,
    isLineMode,
    _child,
    clickMe
  }, {
    setActive
  });
};
export default __sfc_main;
</script>
<style lang="less" scoped>
@import url(../common.less);

.horizontal-tab {
    height: 100% !important;
}

.horizontal-tab-header {
    width: 100%;
}
</style>
